export const SUPPORT_WHATSAPP_URL =
  'https://api.whatsapp.com/send/?phone=5511982711992&text=Oi%2C+tenho+uma+d%C3%BAvida+sobre+o+programa+de+perda+de+peso&type=phone_number&app_absent=0'

export const CONSULTA_AVULSA_PATH = '/agendamento'
// Consulta médica avulsa oferecida a quem tem IMC abaixo do corte do programa.
export const CONSULTA_PIX_PRICE = 99
export const CONSULTA_CARD_PRICE = 108.9
export const WHATSAPP_PROGRAM_DOUBTS_URL =
  'https://api.whatsapp.com/send/?phone=5511982711992&text=Quero+entender+sobre+programa&type=phone_number&app_absent=0'
export const MY_APPOINTMENTS_PATH = '/conta?pagina=consultas'

export const CHOICE_OPTIONS = [
  {
    id: 'journey',
    label: 'Quero começar agora minha jornada de emagrecimento'
  },
  {
    id: 'pharmacy',
    label: 'Já tenho uma orientação médica e quero encontrar produtos'
  }
] as const

export const DECLINE_OPTIONS = [
  { id: 'budget', label: 'Está fora do meu orçamento agora' },
  { id: 'think', label: 'Quero pensar com mais calma' },
  { id: 'no_medication', label: 'Não quero usar medicamento' },
  { id: 'other_professional', label: 'Já tenho outro profissional' },
  { id: 'time', label: 'Não tenho tempo neste momento' },
  { id: 'doubts', label: 'Ainda tenho dúvidas' },
  { id: 'other', label: 'Outro motivo' }
] as const

export const imcCategory = (imc: number) => {
  if (imc < 18.5) return 'Baixo peso'
  if (imc < 25) return 'Eutrofia'
  if (imc < 30) return 'Sobrepeso'
  if (imc < 35) return 'Obesidade grau I'
  if (imc < 40) return 'Obesidade grau II'
  return 'Obesidade grau III'
}

export const formatImc = (imc: number) => imc.toFixed(1).replace('.', ',')

export const IMC_BANDS = [
  { label: 'Sobrepeso', range: '25 a 29,9', min: 25, max: 30 },
  { label: 'Obesidade grau I', range: '30 a 34,9', min: 30, max: 35 },
  { label: 'Obesidade grau II', range: '35 a 39,9', min: 35, max: 40 },
  { label: 'Obesidade grau III', range: '40 ou mais', min: 40, max: Infinity }
] as const

// Mesma ordem de `weightLossProgramQuestions.js` (api-cannect); a API não devolve a posição da pergunta.
export const CLINICAL_TOPICS: Record<string, string> = {
  cl_weight_duration: 'Histórico de peso',
  cl_tried_before: 'Histórico de peso',
  cl_strategies: 'Histórico de peso',
  cl_health_conditions: 'Histórico de saúde',
  cl_meds_use: 'Histórico de saúde',
  cl_meds_list: 'Histórico de saúde',
  cl_wl_meds_use: 'Medicamentos para peso',
  cl_wl_meds_which: 'Medicamentos para peso',
  cl_wl_meds_experience: 'Medicamentos para peso',
  cl_diet: 'Hábitos e rotina',
  cl_exercise: 'Hábitos e rotina',
  cl_food_relation: 'Hábitos e rotina',
  cl_expectations: 'Objetivo'
}

export const CLINICAL_TEXT_PLACEHOLDERS: Record<string, string> = {
  cl_meds_list: 'Ex.: losartana 50 mg, 1 vez ao dia',
  cl_wl_meds_which: 'Ex.: nome do medicamento e por quanto tempo usou'
}

// Perguntas clínicas vão de 68% (introdução) a 98% (última) da barra de progresso.
export const CLINICAL_PROGRESS_START = 68
export const CLINICAL_PROGRESS_SPAN = 30

export const DECLINE_HELP_TEXT =
  'Nossa equipe tira suas dúvidas sobre o programa, o acompanhamento, os valores e as formas de pagamento. É rápido e sem compromisso.'
